var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgFeedHides = function SvgFeedHides(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#feed-hides_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement(Path, {
    opacity: 0.4,
    d: "M4 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4V1Z"
  }), /*#__PURE__*/React.createElement(Path, {
    opacity: 0.7,
    d: "M2 3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1H2V3Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.889 11.05a.75.75 0 0 1 1.06 1.06L13.062 16l3.889 3.89a.75.75 0 0 1-1.06 1.06L12 17.06l-3.89 3.89a.75.75 0 1 1-1.06-1.06L10.94 16l-3.89-3.89a.75.75 0 0 1 1.06-1.06L12 14.94l3.889-3.89Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M16.95 11.05a.75.75 0 0 0-1.061 0L12 14.94l-3.89-3.89a.75.75 0 1 0-1.06 1.06L10.94 16l-3.89 3.89a.75.75 0 0 0 1.06 1.06L12 17.06l3.89 3.89a.75.75 0 1 0 1.06-1.06L13.06 16l3.89-3.89a.75.75 0 0 0 0-1.06Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Zm2-.5h20a.5.5 0 0 1 .5.5v20a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "feed-hides_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v28H0z"
  })))));
};
export default SvgFeedHides;